export default __webpack_public_path__ + "static/media/khachapuri-round.7e71b5fb.png";